import validate from "/Applications/stvn-git/skjmy-nuxt/src/node_modules/nuxt/dist/pages/runtime/validate.js";
import router_45global from "/Applications/stvn-git/skjmy-nuxt/src/middleware/router.global.ts";
import manifest_45route_45rule from "/Applications/stvn-git/skjmy-nuxt/src/node_modules/nuxt/dist/app/middleware/route-rules.js";
export const globalMiddleware = [
  validate,
  router_45global,
  manifest_45route_45rule
]
export const namedMiddleware = {
  "page-slug": () => import("/Applications/stvn-git/skjmy-nuxt/src/middleware/page-slug.ts"),
  "term-slug": () => import("/Applications/stvn-git/skjmy-nuxt/src/middleware/term-slug.ts")
}